// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__LSipP","Scroll":"Header_Scroll__193fa","logo":"Header_logo__ffv_d","Links":"Header_Links__1P_rI"};